(function($){
    $(document).ready(function(){
        if($('.transport-add-form').length > 0){
            $('.transport-add-form form').find('input, select, textarea').addClass('form-control');
            if($('[data-key="field_65412967ef887"]').length > 0){
                $('[data-key="field_65412967ef887"] thead th.acf-row-handle').first().html('Numer miejsca');
            }
        }
    })
})(jQuery)